import * as React from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { useStore } from 'effector-react'
import Pagination from '@mui/material/Pagination'
import MainTable from '../../components/MainTable'
import { KanbanOfPaidServices } from '../../modules/KanbanOfPaidServices/'
import { PaidServiceFastFilter } from '../../modules/PaidServiceFastFilter/PaidServiceFastFilter'
import { $mainTable } from '../../Api/PaidService/search'
import PaidServicesFilter, { $page, setPage } from './components/PaidServicesFilter'

enum DataType {
  LIST = 'list',
  KANBAN = 'kanban'
}
const DATA_TYPE_LOCAL_STORAGE_KEY = 'dataType'

type DataVariant = {
  label: string
  type: DataType
}

const DATA_VARIANTS: DataVariant[] = [
  { label: 'Список', type: DataType.LIST },
  { label: 'Канбан', type: DataType.KANBAN }
]

export default function PaidServices() {
  const [dataType, setDataType] = React.useState<DataType>(
    (localStorage.getItem(DATA_TYPE_LOCAL_STORAGE_KEY) as DataType) ||
      DataType.LIST
  )
  const mainTable = useStore($mainTable)
  const page = useStore($page)

  React.useEffect(() => {
    localStorage.setItem(DATA_TYPE_LOCAL_STORAGE_KEY, dataType)
  }, [dataType])

  return (
    <>
      <PaidServicesFilter />
      <Box mt={2} mb={1}>
        <PaidServiceFastFilter />
      </Box>
      <Tabs aria-label="wrapped label tabs example" value={dataType}>
        {DATA_VARIANTS.map(({ type, label }) => {
          return (
            <Tab
              value={type}
              label={label}
              key={type}
              onClick={() => setDataType(type)}
            />
          )
        })}
      </Tabs>
      {dataType === DataType.LIST ? (
        <>
          <MainTable mainTable={mainTable} />
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mt={2}
          >
            <Pagination
              //@ts-ignore
              count={mainTable?.data?.totalPageCount}
              page={page}
              onChange={(_, num) => setPage(num)}
            />
          </Box>
        </>
      ) : (
        <KanbanOfPaidServices />
      )}
    </>
  )
}
